export enum ELayoutRegisteredItems {
  LEFT_SIDEBAR = "LEFT_SIDEBAR",
  RIGHT_SIDEBAR = "RIGHT_SIDEBAR",
}
